module.exports = __webpack_public_path__ + "static/media/mmm-phone.0bb1d838.svg";